import { IPrePurchaseAnalytics, IYouTubeBrandConnectMetrics } from '@store/prePurchaseAnalytics'

export const transformYouTubeBrandConnectMetrics = (
  response: IYouTubeBrandConnectMetrics,
): IPrePurchaseAnalytics => {
  return {
    // Map available metrics from Brand Connect API
    avg_impressions: response.avg_views,
    avg_engagement_pct: response.avg_engagement_pct,
    avg_reach: response.avg_reach,
    avg_likes: response.avg_likes,
    avg_comments: response.avg_comments,
    avg_shares: response.avg_shares,
    avg_video_views: response.avg_views,
    total_video_views: response.total_views,

    // New Brand Connect specific metrics
    avg_engaged_views: response.avg_engaged_views,
    avg_videos_added_playlist: response.avg_videos_added_playlist,

    // Metrics to hide for Brand Connect (will be deleted in component)
    est_cpe: undefined,
    est_cpm: undefined,
    est_cpv: undefined,
    est_emv_multiplier: undefined,
    avg_emv: undefined,
    avg_impressions_pct: undefined,
    avg_reach_pct: undefined,

    // Other unavailable metrics - set to undefined for N/A display
    avg_engagement: undefined,
    total_engagement: undefined,
    avg_daily_impressions: undefined,
    avg_daily_engagement: undefined,
    avg_daily_saves: undefined,
    avg_save_pct: undefined,
    avg_daily_pin_clicks: undefined,
    avg_pin_click_pct: undefined,
    avg_daily_outbound_clicks: undefined,
    avg_outbound_click_pct: undefined,
    avg_video_views_pct: undefined,
  }
}
